import {
  GGOBaseComponent,
  IconComponent,
  Translate,
  AppContext,
} from '@galigeo-store/ui-lib';
import { css, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { MenuController } from '../../controllers/menu-controller';
import { publish, PUBSUB_TOPICS } from '../../state/pubsub';

@customElement('admin-page')
export class AdminPage extends GGOBaseComponent {
  @state()
  private modules: any[] = [];

  static get styles() {
    return [
      ...(super.styles ?? []),
      css`
        .icon-container {
          background-color: #eeeeee;
        }
        .slds-icon {
          color: #03234d;
          width: 4rem;
          height: 4rem;
        }
        .card-title {
          padding: 1rem;
        }
        .card-container:hover {
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }
        .card-container {
          cursor: pointer;
          max-width: 20rem;
        }
        .slds-gutters .slds-col {
          padding: 0;
          margin: 0 0.75rem;
        }
        .slds-gutters {
          margin: 0;
        }
      `,
    ];
  }

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    MenuController.getMenu().then((elements) => {
      this.modules = elements.filter(
        (element) => element.adminUrl && element.type,
      );
    });
  }

  handleClick(module: any) {
    const user = AppContext.getCurrentUser();
    let mod = module;
    if (module === 'galigeo') {
      let url =
        user.platformUrl +
        `/viewer/checkCredentials.html?redirect=${encodeURIComponent('./admin?lang=' + user.lang)}`;
      mod = {
        id: 'admin',
        label: 'Galigeo Admin',
        type: 'admin',
        icon: './svg/icons.svg#admin',
        url: url,
      };
    } else if (module !== 'general') {
      mod = { ...module, type: 'admin', id: 'admin', url: module.adminUrl };
    }
    publish(PUBSUB_TOPICS.ADMIN_MODULE_SELECTED, mod);
  }

  render() {
    return html`
      <div class="slds-grid slds-p-around_x-large slds-gutters slds-wrap">
        <ggo-card
          class="slds-col card-container"
          @click=${() => this.handleClick('general')}
        >
          <div class="slds-p-around_x-large icon-container">
            <ggo-icon
              icon="utility:settings"
              size=${IconComponent.LARGE}
              color="#03234d"
            ></ggo-icon>
          </div>
          <h2 class="card-title">${Translate.get('general_admin')}</h2>
        </ggo-card>
        ${this.modules.map((module) =>
      module.adminUrl
        ? html`
                <ggo-card
                  class="slds-col card-container"
                  @click=${() => this.handleClick(module)}
                >
                  <div class="slds-p-around_x-large icon-container">
                    <ggo-icon
                      icon=${module.icon}
                      size=${IconComponent.LARGE}
                      color="#03234d"
                    ></ggo-icon>
                  </div>
                  <h2 class="card-title">${module.label}</h2>
                </ggo-card>
              `
        : null,
    )}
        <ggo-card
          class="slds-col card-container"
          @click=${() => this.handleClick('galigeo')}
        >
          <div class="slds-p-around_x-large icon-container">
            <ggo-icon
              icon="utility:bundle_config"
              size=${IconComponent.LARGE}
              color="#03234d"
            ></ggo-icon>
          </div>
          <h2 class="card-title">Galigeo Admin</h2>
        </ggo-card>
      </div>
    `;
  }
}
